/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Link_Type_InvalidInputs */

const vi_error_shop_link_type_invalid = /** @type {(inputs: Error_Shop_Link_Type_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn loại đích cho nút / liên kết.`)
};

/**

* @param {Error_Shop_Link_Type_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_link_type_invalid = /** @type {((inputs?: Error_Shop_Link_Type_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Link_Type_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_link_type_invalid(inputs)
});